import React, { Component } from 'react';
import { Layout, PageHeader, Tag, Table, Divider,
  Form, Card, Input, Select, Row, Col, Button, Icon, message } from 'antd';
import CommonLayout from '@/components/Documents/common/layout';
import SiderMenu from '@/components/SiderMenu'
import { connect } from '@souche-f2e/muji';
import { getState, dispatch } from '@@/store';
import styles from './index.module.less';
import { IRootState } from '@@/store';
import ToolUtils from './utils';
import { menuData, codeInfo } from './notice-menu-data';
// import { withRouter } from "@souche-f2e/muji";

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;

const {
  MUJI_APP_DARTS_DEV,
  MUJI_APP_DARTS_PREPUB,
  MUJI_APP_DARTS_PROD
} = process.env;

const mapStateToProps = (rootState) => {
  return {
    currentRoute: rootState.router,
    debug: rootState.debug
  };
};

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 15 },
    md: { span: 15 },
  },
};

const submitFormLayout = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 10, offset: 7 },
  },
};

// @withRouter
@connect(mapStateToProps)
@Form.create()

class ToolsLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemPath: '常用工具 / 错误码排查',
      docId: 1
    };
    this.setMenuItemKeyPath = (keyPath) => {
      this.setState(() => {
        return {itemPath: '常用工具 / ' + keyPath}
      })
    };
    this.setDocId = (docId) => {
      this.setState({
        docId: docId
      })
    }
  }

  handleSubmit = formData => {

    // 若用户输入 app 密钥信息，签名过程由前端完成 (避免密钥信息在网间传输)
    // 若用户不填 app 密钥信息，签名过程由后端完成

    const authParams = {
      api: formData.api.trim(),
      host: formData.host,
      data: formData.data.trim(),
    };

    if(formData.appKey && formData.appSecret) {
      authParams.appKey = formData.appKey;
      authParams.appSecret = formData.appSecret;

      const signBody = ToolUtils.createSignBody(authParams);
      signBody.host = formData.host;
      dispatch.debug.api(signBody);
    } else {
      dispatch.debug.api(authParams);
    }

    dispatch.debug.saveParams(authParams);

    this.scrollToAnchor('#showResult');
  };

  handleFormSubmit = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, fieldsValue) => {
      if (err) return;
      this.handleSubmit(fieldsValue);
    });
  };

  scrollToAnchor = anchorName => {
    if (anchorName) {
      const anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  };

  showAppSecret = () => {
    const {
      form: { getFieldDecorator, getFieldValue },
      debug: { debugParams }
    } = this.props;
    const children = [];
    const newApp = getFieldValue('appKey');
    if (!newApp) return children;
    children.push(
      <Form.Item
      {...formItemLayout}
      label="AppSecret"
    >
      {getFieldDecorator('appSecret', {
        initialValue: debugParams.appKey,
        rules: [{ required: true, message: 'AppSecret 不允许为空！', min: 1 }],
      })(<Input placeholder="请输入AppSecret" />)}
    </Form.Item>
    );
    return children;
  };

  getChildrenByDocId = () => {
    const {
      form: { getFieldDecorator },
      debug: { debugParams, debugResult, reqBody }
    } = this.props;
    // 使用 getState 方式, 若通过 reducer 或者 effect 更新了 store 的状态，组件并不会重新渲染刷新
    // const debug = getState().debug;

    if(this.state.docId === 0) {
      const coedColumns = [
        {
          title: 'HTTP码',
          dataIndex: 'httpCode',
          key: 'httpCode',
        },
        {
          title: 'API码',
          width: '20%',
          dataIndex: 'apiCode',
          key: 'apiCode',
        },
        {
          title: '描述',
          width: '22%',
          dataIndex: 'meaning',
          key: 'meaning',
        },
        {
          title: '常见解决方案',
          width: '42%',
          key: 'solution',
          render: (text, record) => {
            const getSolutions = solutionList => {
              const children = [];
              solutionList.forEach(solution => children.push(<p> {solution} </p>));
              return children;
            };

            if (record.solution.length > 0) {
              return <span>{getSolutions(record.solution)}</span>;
            }
            return <span>暂无方案说明</span>;
          },
        },
      ];
      return (<Layout.Content className={styles.layoutContent}>
        <div className={styles.breadcrumb}>{this.state.itemPath}</div>
        <PageHeader
          title="错误码排查介绍"
          tags={<Tag color="red">持续更新</Tag>}
          extra={
            <div>
              <span key="3">更新时间：2019-07-31 &nbsp;&nbsp; 访问次数：10000</span>
            </div>
          }
        >
          <div className={styles.content}>
            <p className={styles.text}>本文主要引导大家通过开放平台官方提供的API错误码，对调用的结果可以进行简单的分析。</p>
            <Table
              bordered={true}
              pagination={false}
              rowKey={item => item.meaning || 'key'}
              columns={coedColumns}
              dataSource={codeInfo}
            />
          </div>
        </PageHeader>
        <Divider className={styles.line}/>
        <p className={styles.contentFooter}>找到解决办法了吗？前往
          &nbsp;<a href="/#/FAQ" target="_blank" >FAQ</a> &nbsp;
          再找找
        </p>
      </Layout.Content>);
    } else {
      return (
        <Layout.Content className={styles.layoutContent}>
          <div className={styles.breadcrumb}>{this.state.itemPath}</div>
          <div className={styles.cardList}>
            <Col span={12} className={styles.resultCol}>
            <Card title="接口参数输入" className={styles.inputCard}>
              <Form onSubmit={this.handleFormSubmit} hideRequiredMark style={{ marginTop: 8 }}>
                <FormItem {...formItemLayout} className={styles.inputForm} label="调试环境">
                  {getFieldDecorator('host', {
                    initialValue: debugParams.host || MUJI_APP_DARTS_DEV,
                    rules: [{ required: true, message: '调用地址不允许为空' }],
                  })(
                    <Select
                      // loading={hostLoading}
                      // onChange={this.saveFormData('host')}
                      placeholder="请选择调试环境"
                      style={{ width: '100%' }}
                    >
                      <Option key={MUJI_APP_DARTS_DEV}>测试环境</Option>
                      <Option key={MUJI_APP_DARTS_PREPUB}>预发环境</Option>
                      <Option key={MUJI_APP_DARTS_PROD}>线上环境</Option>
                    </Select>
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="AppKey">
                  {getFieldDecorator('appKey', {
                    initialValue: debugParams.appKey,
                    // rules: [{ required: true, message: 'appKey不允许为空' }],
                  })(
                    <Input
                      // onChange={this.saveFormData('appKey')}
                      placeholder="不填则默认系统分配"
                      style={{ width: '100%' }}
                    />
                  )}
                </FormItem>
                {this.showAppSecret()}
                <FormItem {...formItemLayout} label="API名称">
                  {getFieldDecorator('api', {
                    initialValue: debugParams.api,
                    rules: [{ required: true, message: 'API 不允许为空' }],
                  })(
                    <TextArea
                      rows={2}
                      // onChange={this.saveFormData('api')}
                      placeholder="请填写要调试的API名称"
                      style={{ width: '100%' }}
                    />
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="请求数据">
                  {getFieldDecorator('data', {
                    initialValue: debugParams.data,
                    rules: [{ required: true, message: '请求数据不允许为空' }],
                  })(
                    <TextArea
                      rows={3}
                      // onChange={this.saveFormData('data')}
                      placeholder="请求数据必须是json格式的字符串  eg: {&quot;company&quot;:&quot;dasouche&quot;,&quot;domain&quot;:&quot;souche.com&quot;}"
                      style={{ width: '100%' }}
                    />
                  )}
                </FormItem>
                <FormItem {...submitFormLayout} style={{ marginTop: 32 }}>
                  <Button type="primary"  htmlType="submit" style={{ width: 180 }}>
                  点击调试
                  </Button>
                </FormItem>
              </Form>
            </Card>
            </Col>
          <Col span={12} className={styles.resultCol}>
            <Card className={styles.outPutCard} title="您的请求入参">
              <pre className={styles.autoNewline}>{JSON.stringify(reqBody || {}, null, 1)}</pre>
            </Card>
          </Col>
          <Col span={12} className={styles.resultCol}>
            <Card id="#showResult" className={styles.outPutCard} title="您的响应结果">
              <pre className={styles.autoNewline}>
                {JSON.stringify(
                  debugResult || {},
                  null,
                  2
                )}
              </pre>
            </Card>
          </Col>
          </div>
          <div className={styles.line}>
          <Divider />
          <p className={styles.contentFooter} >如何获取调试接口信息？前往
            &nbsp;<a href="/#/documents/docs" target="_blank" >API 文档</a> &nbsp;
          </p>
          </div>
        </Layout.Content>
      );
    }
  };

  render() {
    const {
      currentRoute,
    } = this.props;
    // 文档目录
    const docMenu = true;

    return (
      <Layout
        tabKey={'common_tools'}
        className={styles.container}>
        <SiderMenu
          menuData={menuData}
          currentRoute={currentRoute}
          className={styles.siderMenu}
          isDocMenu={docMenu}
          setMenuItemKeyPath={this.setMenuItemKeyPath}
          setDocId={this.setDocId}
          titleName='常用工具'
          style={{
            padding: '16px 0',
            width: '100%',
            borderRight: 'none'
          }}
        />
        {this.getChildrenByDocId.bind(this)()}
      </Layout>
    )
  }
}

export default function() {
  return (
    <CommonLayout tabKey={'common_tools'}>
      <ToolsLayout />
    </CommonLayout>
  )
}
